module.exports = __webpack_public_path__ + "img/crie@2x.32b0501e.png";